import { Link } from "react-router-dom";

const SideBar = ({ path }) => (
  <div className="iq-sidebar">
    <div className="iq-sidebar-logo d-flex justify-content-between">
      <Link to="/" id="logo">
        <img
          src="data:image/png;base64,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"
          className="img-fluid"
          alt=""
          style={{ height: "23px", marginTop: "6px" }}
        />
        {/* <span>Cloudefense</span> */}
      </Link>
      {/* <div className="iq-menu-bt align-self-center">
        <div className="wrapper-menu">
          <div className="line-menu half start" />
          <div className="line-menu" />
          <div className="line-menu half end" />
        </div>
      </div> */}
    </div>
    <div
      id="sidebar-scrollbar"
      data-scrollbar="true"
      tabIndex={-1}
      style={{ overflow: "hidden", outline: "none" }}
    >
      <div className="scroll-content">
        <nav className="iq-sidebar-menu">
          <ul id="iq-sidebar-toggle" className="iq-menu">
            <li className="iq-menu-title">
              <i className="ri-separator" />
              {/* <span>Main</span> */}
            </li>
            <li className={path === "/" ? "active" : ""}>
              <Link
                to="/"
                className="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                id="dashboard"
              >
                <i className="las la-home" />
                <span>Dashboard</span>
              </Link>
            </li>
            <li className={path === "/users" ? "active" : ""}>
              <Link
                to="/users"
                className="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                id="users"
              >
                <i className="las la-user-tie" />
                <span>Users</span>
              </Link>
            </li>
            <li className={path === "/customers" ? "active" : ""}>
              <Link
                to="/customers"
                className="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                id="customers"
              >
                <i className="lab la-elementor" />
                <span>Customers</span>
              </Link>
            </li>
            <li className={path === "/tenants" ? "active" : ""}>
              <Link
                to="/tenants"
                className="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                id="tenants"
              >
                <i className="lab la-codepen" />
                <span>Tenants</span>
              </Link>
            </li>
            <li className={path === "/subscriptions" ? "active" : ""}>
              <Link
                to="/subscriptions"
                className="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                id="subscriptions"
              >
                <i className="las la-file-contract" />
                <span>Subscriptions</span>
              </Link>
            </li>
            <li className={path === "/teams" ? "active" : ""}>
              <Link
                to="/teams"
                className="iq-waves-effect collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                id="teams"
              >
                <i class="las la-users"></i>
                <span>Teams</span>
              </Link>
            </li>



          </ul>
        </nav>
        <div className="p-3" />
      </div>
      <div
        className="scrollbar-track scrollbar-track-x"
        style={{ display: "none" }}
      >
        <div
          className="scrollbar-thumb scrollbar-thumb-x"
          style={{
            width: "260px",
            transform: "translate3d(0px, 0px, 0px)",
          }}
        />
      </div>
      <div
        className="scrollbar-track scrollbar-track-y"
        style={{ display: "block" }}
      >
        <div
          className="scrollbar-thumb scrollbar-thumb-y"
          style={{
            height: "111.006px",
            transform: "translate3d(0px, 0px, 0px)",
          }}
        />
      </div>
    </div>
  </div>
);

export default SideBar;
